import React from 'react';
import { Helmet } from 'react-helmet';

const SEOHead = ({ 
  title = "The Random Store - Custom Products",
  description = "Discover curated randomness at The Random Store. Shop unique, custom, and modern products across categories with a seamless experience.",
  keywords = "custom photo frame, custom lamps, custom photo frames, personalized photo frames, custom picture frames, lithophane lamps, custom name keychains, personalized keychains, flexi keychains, action figures, custom home decor, personalized gifts, custom products online, unique gift items, custom printing services, the random store, custom gifts india, personalized products online india",
  image = "/images/The-Random-Store---Logo---Transparent%20-%20Copy.png",
  url = "https://therandomstores.com",
  type = "website",
  product = null // For product-specific SEO
}) => {
  // Generate structured data for products
  const generateProductStructuredData = (product) => {
    if (!product) return null;

    const structuredData = {
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": product.name,
      "description": product.description || description,
      "image": product.imageUrls || product.images || [image],
      "brand": {
        "@type": "Brand",
        "name": "The Random Store"
      },
      "offers": {
        "@type": "Offer",
        "price": product.salePrice || product.price,
        "priceCurrency": "INR",
        "availability": product.stock > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
        "seller": {
          "@type": "Organization",
          "name": "The Random Store"
        }
      }
    };

    // Add reviews if available
    if (product.reviewSummary && product.reviewSummary.totalReviews > 0) {
      structuredData.aggregateRating = {
        "@type": "AggregateRating",
        "ratingValue": product.reviewSummary.averageRating,
        "reviewCount": product.reviewSummary.totalReviews
      };
    }

    return structuredData;
  };

  const structuredData = product ? generateProductStructuredData(product) : {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "The Random Store",
    "url": "https://therandomstores.com",
    "logo": "https://therandomstores.com/images/The-Random-Store---Logo---Transparent%20-%20Copy.png",
    "sameAs": [
      // Add your social media URLs here
    ]
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="The Random Store" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Additional SEO tags */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="author" content="The Random Store" />
      <link rel="canonical" href={url} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEOHead;
